import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs'
import { PermissionService } from './permission.service'

export const defaultRouteGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService)
  const router = inject(Router)

  return permissionService
    .getFirstAllowedRoute$()
    .pipe(map((fallbackRoute) => router.createUrlTree([fallbackRoute ?? '/forbidden'])))
}
